import { render, staticRenderFns } from "./IconCalendar.vue?vue&type=template&id=444a3347&scoped=true"
import script from "./IconCalendar.vue?vue&type=script&lang=js"
export * from "./IconCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a3347",
  null
  
)

export default component.exports